import store from './store/index'
// import router from './router/index'

export default {
    handleErrorDialog(error) {
        // console.log('this is helper handleError')
        if (error.response) {
            let response = error.response;
            // console.log(response)
            let data = response.data;
            // console.log(data.status)
            switch (response.status) {
                case 403:
                    store.commit('setShowDialog', { dialogMsg: response.statusText })
                    break
                case 400:
                    store.commit('setShowDialog', { dialogMsg: response.statusText })
                    break
                case 500:
                    store.commit('setShowDialog', { dialogMsg: response.statusText })
                    break
                default:
                    if (data.status == 0) {
                        const dialogMsg = data.message
                        store.commit('setShowDialog', { dialogMsg })
                    }
                    break
            }
        } else if (error.request) {
            // let req = error.request;
            // console.log('errorHandle: error request', error.request.response);
            let errReqMsg = JSON.parse(error.request.response)
            // console.log(errReqMsg.message)
            store.commit('setShowDialog', { dialogMsg: errReqMsg.message })
        } else {

            // let msg = error.message;
            console.log('Error', error.message);
        }
    },
    handleSuccessDialog(response) {
        // console.log('this is helper handleSuccess')
        if (response) {
            let data = response.data;
            // console.log('dari handle success', data)
            let dialogMsg = data.message
            store.commit('setShowDialog', { dialogMsg })
            return data
        }
    },
    handleError(error) {
        // console.log('this is helper handleError')
        if (error.response) {
            let response = error.response;
            // console.log(response)
            let data = response.data;
            // console.log(data.status)
            switch (response.status) {
                case 403:
                    store.commit('setShowSnackbar', { snackbarMsg: response.statusText, snackbarColor: 'red' })
                    break
                case 400:
                    store.commit('setShowSnackbar', { snackbarMsg: response.data.message, snackbarColor: 'red' })
                    break
                case 500:
                    store.commit('setShowSnackbar', { snackbarMsg: response.data.message, snackbarColor: 'red' })
                    break
                default:
                    if (data.status == 0) {
                        const snackbarMsg = data.message
                        const snackbarColor = 'red'
                        store.commit('setShowSnackbar', { snackbarMsg, snackbarColor })
                    }
                    break
            }
        } else if (error.request) {
            // let req = error.request;
            // console.log('errorHandle: error request', error.request.response);
            let errReqMsg = JSON.parse(error.request.response)
            // console.log(errReqMsg.message)
            store.commit('setShowSnackbar', { snackbarMsg: errReqMsg.message, snackbarColor: 'red' })
        } else {

            // let msg = error.message;
            console.log('Error', error.message);
        }
    },
    handleSuccess(response) {
        // console.log('this is helper handleSuccess')
        if (response) {
            let data = response.data;
            // console.log('dari handle success', data)
            let snackbarMsg = data.message
            let snackbarColor = data.status == 0 ? 'red' : 'green'
            store.commit('setShowSnackbar', { snackbarMsg, snackbarColor })
            return data
        }
    },
    handleSuccessData(response) {
        // console.log('this is helper handleSuccess')
        if (response) {
            let data = response.data;
            // console.log('dari handle success', data)
            // let snackbarMsg = data.message
            // let snackbarColor = data.status == 0 ? 'red' : 'green'
            // store.commit('setShowSnackbar', { snackbarMsg, snackbarColor })
            return data
        }
    },
    // hasFeature (featureCd) {
    //     const allowedFeature = store.state.features.filter( feature => {
    //         return feature.featureCd == featureCd
    //     })
    //     return allowedFeature.length > 0 ? true : false
    // },
    // requiredFeature (featureCd) {
    //   if (!this.hasFeature(featureCd)) {
    //     router.push({ name: "forbidden" });
    //   }
    // },
    arrToObj(array, keyField) {
        return array.reduce((obj, item) => {
            obj[item[keyField]] = item
            return obj
        }, {})
    },
    // humanFormat (number, options) {
    //     if (options === undefined) {
    //         options = {
    //             locale: "id-ID",
    //             prefix: "",
    //             suffix: "",
    //             length: 11,
    //             precision: 0
    //         }
    //     }

    //     if (isNaN(number)) {
    //         number = 0;
    //     } else {
    //         // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
    //         number = Number(number).toLocaleString(options.locale, {
    //         maximumFractionDigits: options.precision,
    //         minimumFractionDigits: options.precision
    //         });
    //     }
    //     return number;
    // },
    // machineFormatJUNK (number, options) {//kayanya ini ga guna karena hasilnya ngaco
    //     if (options === undefined) {
    //         options = {
    //             locale: "id-ID",
    //             prefix: "",
    //             suffix: "",
    //             length: 11,
    //             precision: 0
    //         }
    //     }
    //     if (number) {
    //       number = this.cleanNumber(number);
    //       // Ajustar quantidade de zeros Ã esquerda
    //       number = number.padStart(parseInt(options.precision) + 1, "0");
    //       // Incluir ponto na casa correta, conforme a precisÃ£o configurada
    //       number =
    //         number.substring(
    //           0,
    //           number.length - parseInt(options.precision)
    //         ) +
    //         "." +
    //         number.substring(
    //           number.length - parseInt(options.precision),
    //           number.length
    //         );
    //       if (isNaN(number)) {
    //         number = options.valueWhenIsEmpty;
    //       }
    //     } else {
    //       number = options.valueWhenIsEmpty;
    //     }
    //     if (options.precision === 0) {
    //       number = this.cleanNumber(number);
    //     }
    //     return number;
    // },
    // cleanNumberJUNK (value) {//ini juga ga guna
    //     let result = "";
    //     if (value) {
    //       let flag = false;
    //       let arrayValue = value.toString().split("");
    //       for (var i = 0; i < arrayValue.length; i++) {
    //         if (this.isInteger(arrayValue[i])) {
    //           if (!flag) {
    //             // Retirar zeros Ã esquerda
    //             if (arrayValue[i] !== "0") {
    //               result = result + arrayValue[i];
    //               flag = true;
    //             }
    //           } else {
    //             result = result + arrayValue[i];
    //           }
    //         }
    //       }
    //     }
    //     return result;
    // },
    isInteger(value) {
        let result = false;
        if (Number.isInteger(parseInt(value))) {
            result = true;
        }
        return result;
    }
};